module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2z"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#eth"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_c('em', [_vm._v("Ethnomusicology Multimedia Series Preface")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_c('em', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Introduction  ·  "), _c('em', [_vm._v("Radical Jewish Music in Manhattan")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Jewish Music  ·  "), _c('em', [_vm._v("The Art of Getting It Wrong")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Breaking a Thick Silence  ·  "), _c('em', [_vm._v("A Community Emerges")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("From the Inexorable to the Ineffable  ·  "), _c('em', [_vm._v("John Zorn’s")]), _vm._v(" Kristallnacht "), _c('em', [_vm._v("and the Masada Project")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Rethinking Identity  ·  "), _c('em', [_vm._v("G - d Is My Co-Pilot’s Queer Dada Judaism")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Shelley Hirsch and Anthony Coleman  ·  "), _c('em', [_vm._v("Music and Memory from the “Nowhere Place”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_c('em', [_vm._v("Notes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/source#sou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_c('em', [_vm._v("Sources")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("·"), _c('span', {
    staticClass: "space"
  }, [_c('em', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0